import React, { useEffect, useState } from "react";
import axios from "axios";
import Papa from "papaparse";

import CoronaChart from "components/CoronaChartsAmazon";
import Layout from "components/Layout";
import Loading from "components/Loading";
import DataTable from "components/DataTableAmazon";
import CountySearch from "components/CoronaChartsNew/CountySearch";

import { formatName, numberWithCommas } from "helpers/miscHelpers";
import {
  createTotalsObjectStates,
  processStateDataNew,
  stateSorterJH,
  stateNames,
  processAmazonData,
  createTotalsObjectAmazon,
  stateCodeToName,
} from "helpers/CoronaHelpersNew";

import {
  StyledContainer,
  StyledUIGrid,
  StyledAlertBox,
  StyledDivider,
  StyledBorderBox,
} from "styles/pageStyles";

import { StyledSummaryBox } from "components/CoronaChartsNew/styles";

const dataURL = "https://api.covidtracking.com/v1/states/daily.json";
const todayDataURL = "https://api.covidtracking.com/v1/states/current.json";

// const dataURL = "http://localhost:8000/amazonData.json";

const initialStates = ["California", "", "", ""];

const NewUsData = () => {
  const [countyData, setCountyData] = useState(null);
  const [loadedData, setLoadedData] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [theTotals, setTheTotals] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [countyTableData, setCountyTableData] = useState(null);
  const [chartType, setChartType] = useState("positiveIncrease");
  // const [noteVisible, setNoteVisible] = useState(true);

  function processJsonData(data) {
    const newData = processAmazonData(data);
    setLoadedData(newData);
  }

  // effects that run on initial load
  useEffect(() => {
    async function dataFetch() {
      const dataStream = await axios.get(dataURL);
      const dataAll = dataStream.data;
      // console.log("dataFetch -> dataAll", dataAll);

      const nonNumericColumns = ["name", "state", "dateModified", "grade"];

      const todayDataStream = await axios.get(todayDataURL);
      const todayData = todayDataStream.data.map((d, i) => {
        d.name = stateCodeToName(d.state);
        Object.keys(d).forEach((key) => {
          if (!nonNumericColumns.includes(key)) {
            d[`${key}`] = Number(d[`${key}`]);
          }
        });
        return d;
      });

      // console.log("dataFetch -> todayData", todayData);
      setTableData(todayData);

      processJsonData(dataAll);
    }

    dataFetch();
  }, []);

  return (
    <Layout title="COVID-19 (Coronavirus) US Testing Data Graphs">
      <StyledContainer>
        <section>
          <StyledSummaryBox>
            <h3>
              Testing Info
              <br />
              <small>(data from "The COVID Tracking Project")</small>
            </h3>
          </StyledSummaryBox>

          <StyledUIGrid className="ui-grid">
            <div className="left-side">
              <StyledBorderBox>
                <h2>
                  Data Over Time:{" "}
                  {chartType === "positiveIncrease"
                    ? "New Positive Tests"
                    : chartType === "negativeIncrease"
                    ? "New Negative Tests"
                    : chartType === "totalTestResults"
                    ? "Total Tests"
                    : chartType === "totalTestResultsIncrease"
                    ? "New Tests"
                    : chartType === "hospitalizedIncrease"
                    ? "New Hospitalizations"
                    : chartType === "hospitalizedCurrently"
                    ? "Currently Hospitalized"
                    : chartType === "hospitalizedCumulative"
                    ? "Total Hospitalized (Cumulative)"
                    : chartType === "deathIncrease"
                    ? "New Deaths"
                    : chartType === "death"
                    ? "Total Deaths"
                    : formatName(chartType)}
                </h2>

                <p
                  style={{
                    textAlign: "center",
                    fontStyle: "italic",
                    fontSize: "12px",
                  }}
                >
                  This graphing data updates once per day, typically between 4pm
                  - 6pm Eastern.
                </p>

                {loadedData && (
                  <CoronaChart
                    chartType={chartType}
                    dateCount={10}
                    initialStates={initialStates}
                    loadedData={loadedData}
                    setChartType={setChartType}
                    isUS
                  />
                )}
              </StyledBorderBox>

              <StyledDivider />

              {/* {countyData && (
                <div>
                  <CountySearch data={countyData} />
                </div>
              )} */}

              {!loadedData && <Loading />}
            </div>

            <div className="right-side">
              <StyledBorderBox>
                <h2 style={{ marginBottom: "10px" }}>
                  US Testing Data Overview
                </h2>

                {tableData && tableData.length > 0 && (
                  <DataTable data={tableData} />
                )}
              </StyledBorderBox>
            </div>
          </StyledUIGrid>
        </section>
      </StyledContainer>
    </Layout>
  );
};

export default NewUsData;
